module.exports = __webpack_public_path__ + "static/starbucks-387b2f9f361b07f652a2e885c971b469.jpg";